/* eslint-disable import/no-cycle */
/* eslint-disable max-classes-per-file */
import 'reflect-metadata';
import { IsUUID, ValidateNested, IsInt, IsOptional, IsString } from 'class-validator';
import { Type } from 'class-transformer';
import { MaterialDTO } from './material';

export class InstrumentDTO {
  @IsUUID()
  instrumentId!: string;

  @ValidateNested()
  @Type(() => MaterialDTO)
  material!: MaterialDTO;

  @IsOptional()
  @IsString()
  description?: string;

  @IsInt()
  amount!: number;

  @IsInt()
  @IsOptional()
  expectedAmount?: number;

  @IsString()
  @IsOptional()
  lastSynchronisation?: string;
}

export class SetImportInstrumentDTO {
  @IsString()
  externalId!: string;

  @IsString()
  serialNumber!: string;

  @IsString()
  manufacturerArticleNumber!: string;

  @IsInt()
  @IsOptional()
  position?: number;

  @IsInt()
  amount!: number;
}
